/* KORZAVI Orbit v8 — numbered catalog pages and the private feedback form.
   Loaded after theme.min.js; uses its panels (data-open / data-close) and filter loader (data-filter-link). */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Catalog pages: jump back to the top of the grid when changing page ---------- */
  const gridTop = () => {
    const layout = $('[data-collection-root] .coll__layout') || $('#kz-grid');
    if (!layout) return null;
    const header = $('[data-header]');
    const bar = $('.coll__sticky');
    const offset = (header ? header.offsetHeight : 0) + (bar ? bar.offsetHeight : 0) + 12;
    return Math.max(0, layout.getBoundingClientRect().top + window.scrollY - offset);
  };
  let pendingFocus = false;
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-page-link]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    const top = gridTop();
    if (top !== null && top < window.scrollY) window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    pendingFocus = true;
  }, true);
  const collRoot = $('[data-collection-root]');
  if (collRoot && 'MutationObserver' in window) {
    new MutationObserver(() => {
      if (!pendingFocus) return;
      pendingFocus = false;
      const grid = $('#kz-grid');
      if (!grid) return;
      grid.setAttribute('tabindex', '-1');
      grid.focus({ preventScroll: true });
      const top = gridTop();
      if (top !== null && Math.abs(top - window.scrollY) > 40) window.scrollTo({ top, behavior: 'auto' });
    }).observe(collRoot, { childList: true });
  }

  /* ---------- Feedback form: sent in the background, so the page (and any other form on it) stays as it is ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-feedback]');
    if (!form || form.dataset.native) return;
    e.preventDefault();
    const ok = $('[data-fb-ok]', form);
    const err = $('[data-fb-error]', form);
    const fields = $('[data-fb-fields]', form);
    const btn = $('[type=submit]', form);
    const page = $('[data-fb-page]', form);
    if (page) page.value = location.href.split('#')[0];
    err.hidden = true;
    btn.disabled = true;
    btn.classList.add('is-off');
    const sendNatively = () => { form.dataset.native = '1'; HTMLFormElement.prototype.submit.call(form); };
    try {
      const r = await fetch(form.action.split('#')[0], { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
      if (/\/challenge/.test(r.url)) return sendNatively(); /* Shopify asks for a captcha: finish on its page */
      if (!r.ok || !/contact_posted=true/.test(r.url)) throw new Error('not sent');
      fields.hidden = true;
      ok.hidden = false;
      form.reset();
      ok.setAttribute('tabindex', '-1');
      ok.focus({ preventScroll: true });
    } catch (ex) {
      if (navigator.onLine === false) { err.hidden = false; return; }
      sendNatively();
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-off');
    }
  });
  /* Opening the panel again after a message was sent shows a fresh form */
  document.addEventListener('kz:open', (e) => {
    if (e.detail !== 'kz-feedback') return;
    const form = $('#kz-feedback form[data-feedback]');
    if (!form) return;
    const ok = $('[data-fb-ok]', form);
    if (ok && !ok.hidden) {
      ok.hidden = true;
      $('[data-fb-fields]', form).hidden = false;
    }
  });

  /* ---------- Catalog price filter: search once both prices are in, not after the first number ----------
     theme.min.js reloads the grid on every "change" of a filter field; for the two price boxes that
     change is held back here and sent only when min and max are both filled (or both emptied to clear).
     Enter still searches right away with whatever is typed. */
  const PRICE = /^filter\.v\.price\.(gte|lte)$/;
  const isPrice = (el) => !!(el && el.name && PRICE.test(el.name) && el.form && el.form.matches('[data-filters]'));
  const priceBoxes = (form) => [form.elements['filter.v.price.gte'], form.elements['filter.v.price.lte']];
  let priceRelease = false;
  let priceTimer = 0;
  document.addEventListener('change', (e) => {
    if (priceRelease || !isPrice(e.target)) return;
    e.stopImmediatePropagation();
  }, true);
  const applyPrice = (form) => {
    const [min, max] = priceBoxes(form);
    if (!min || !max) return;
    const a = parseFloat(min.value);
    const b = parseFloat(max.value);
    if (!isNaN(a) && !isNaN(b) && a > b) { min.value = String(b); max.value = String(a); }
    priceRelease = true;
    max.dispatchEvent(new Event('change', { bubbles: true }));
    priceRelease = false;
  };
  document.addEventListener('input', (e) => {
    if (!isPrice(e.target)) return;
    const form = e.target.form;
    const [min, max] = priceBoxes(form);
    if (!min || !max) return;
    clearTimeout(priceTimer);
    const hasMin = min.value.trim() !== '' && !isNaN(parseFloat(min.value));
    const hasMax = max.value.trim() !== '' && !isNaN(parseFloat(max.value));
    const params = new URLSearchParams(location.search);
    const applied = params.has('filter.v.price.gte') || params.has('filter.v.price.lte');
    if ((hasMin && hasMax) || (!min.value.trim() && !max.value.trim() && applied)) {
      priceTimer = setTimeout(() => applyPrice(form), 700);
    }
  });
  document.addEventListener('submit', () => clearTimeout(priceTimer), true);

  /* ---------- Product details: long descriptions fold behind a button; their images open in the zoom viewer ---------- */
  document.querySelectorAll('[data-pdesc]').forEach((box) => {
    const more = box.parentElement.querySelector('[data-pdesc-more]');
    const btn = more && more.querySelector('button');
    if (!more || !btn) return;
    let opened = false;
    const check = () => {
      if (opened || !box.offsetParent) return;
      const fold = window.innerWidth < 750 ? 620 : 860;
      box.style.setProperty('--fold', `${fold}px`);
      /* Images load lazily, so a description with several of them folds right away instead of collapsing later while being read */
      const imgs = [...box.querySelectorAll('img')];
      const waiting = imgs.length >= 2 && imgs.some((i) => !i.complete);
      const tall = waiting || box.scrollHeight > fold + 260;
      box.classList.toggle('is-folded', tall);
      more.hidden = !tall;
    };
    check();
    box.querySelectorAll('img').forEach((img) => { if (!img.complete) img.addEventListener('load', check, { once: true }); });
    let rt = 0;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(check, 150); }, { passive: true });
    document.addEventListener('click', (e) => { if (e.target.closest('[data-tab="desc"]')) requestAnimationFrame(check); });
    btn.addEventListener('click', () => {
      opened = true;
      box.classList.remove('is-folded');
      more.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      box.setAttribute('tabindex', '-1');
      box.focus({ preventScroll: true });
    });
  });
  document.addEventListener('click', (e) => {
    const img = e.target.closest('[data-pdesc] img');
    if (!img || img.closest('a')) return;
    const view = $('[data-zoom-img]');
    if (!view || !(window.KZ && typeof window.KZ.openPanel === 'function')) return;
    const zbox = $('[data-zoom-box]');
    view.src = img.currentSrc || img.src;
    view.style.width = '100%';
    if (zbox) zbox.classList.remove('is-zoomed');
    window.KZ.openPanel('kz-zoom');
  });
})();
